import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'pn-input',
  templateUrl: './pn-input.component.html',
  styleUrls: ['./pn-input.component.scss'],
})
export class PnInputComponent implements OnInit {
  @Input() public id;
  @Input() public type;
  @Input() public name;
  @Input() public label;
  @Input() public value;
  @Input() public control;
  @Input() public disabled;
  @Input() public required;
  @Input() public placeholder;
  @Input() public error;
  @Input() public showForgotPassword: boolean;

  ngOnInit() {}
}
